import { EventEmitter, Injectable } from '@angular/core';
import { StoredNotification } from '@models/notifications';
import { PersistentStateServiceBase } from 'mbs-ui-kit/services/storage/persistent-state-base.service';
import { PerPageSize } from 'mbs-ui-shared@models/Paging';

const RESELLER_STATE_NAMESPACE = 'mbsResellerPersistentState';

export class ResellerPersistentState {
  purchaseHistoryPerPage = PerPageSize.Large;
  notificationsMuted = false;
  notifications: StoredNotification[] = [];
  notificationsOwner = '';
}

@Injectable()
export class ResellerAppPersistentStateService extends PersistentStateServiceBase<ResellerPersistentState> {
  constructor() {
    super(ResellerPersistentState, new EventEmitter<string>());
    this.getEmitterInstance().emit(RESELLER_STATE_NAMESPACE);
    this.listenStorageChange();
  }
}
